import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import App from './App.vue'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(autoAnimatePlugin)
// eslint-disable-next-line no-undef
app.config.globalProperties.vals = { ...vnObject }
app.mount('#collection')
